
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('radialGradient',{attrs:{"id":"24-a","cx":"50%","cy":"50%","r":"100%","fx":"50%","fy":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#5E6273"}}),_c('stop',{attrs:{"offset":"100%"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"32","cy":"32","r":"25.5","fill":"#FFF","stroke":"#FFF","stroke-width":"3"}}),_c('circle',{attrs:{"cx":"32","cy":"32","r":"24","fill":"url(#24-a)"}}),_c('circle',{attrs:{"cx":"26","cy":"25","r":"12","fill":"#F7F8FC"}}),_c('path',{attrs:{"fill":"#353741","fill-rule":"nonzero","d":"M23.559 30.915c1.678.213 3 .026 3.953-.563.934-.59 1.424-1.534 1.483-2.829.038-.825-.161-1.562-.591-2.21-.423-.647-1.024-1.135-1.806-1.464.733-.15 1.3-.452 1.7-.907.394-.456.608-1.045.645-1.768.057-1.12-.257-2.05-.932-2.79-.66-.737-1.589-1.181-2.8-1.335-1.204-.152-2.206.048-3.02.6-.828.549-1.352 1.373-1.559 2.474-.135.716-.063 1.344.22 1.886.287.542.776.975 1.466 1.298-.848.117-1.555.437-2.123.958-.576.521-.946 1.19-1.104 2.005-.247 1.271.008 2.309.776 3.115.785.808 2.02 1.319 3.692 1.53zm.827-8.352c-.508 0-.909-.155-1.203-.465-.295-.31-.442-.729-.442-1.258 0-.517.149-.929.446-1.236.298-.306.697-.46 1.199-.46.513 0 .917.152 1.212.456.294.303.442.717.442 1.24 0 .529-.148.948-.442 1.258-.295.31-.699.465-1.212.465zm0 6.259c-.578 0-1.044-.19-1.4-.569-.356-.378-.534-.877-.534-1.497 0-.619.178-1.117.534-1.492.356-.376.822-.564 1.4-.564.583 0 1.053.188 1.409.564.356.375.534.873.534 1.492 0 .608-.18 1.104-.539 1.488-.358.385-.827.578-1.404.578z"}})])])
          )
        }
      }
    